
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punebushirerentalsservice() {



    const cardData =
    {
        keyword: 'Pune Bus Hire Rental Service',
        heading: 'Amruta Travels: Pune Bus Hire Rental Service',
        headingDescription: 'Amruta Travels offers Pune Bus Hire Rental Service, providing a comprehensive range of transportation solutions to meet diverse travel needs. Whether you are planning a corporate event, wedding, school trip, or a family outing, our fleet of well-maintained buses ensures a comfortable and hassle-free journey. With experienced drivers, punctual service, competitive pricing, and 24/7 support, we make group travel simple and stress-free. Choose from our variety of buses, including 32-seater, 35-seater, 45-seater, and 50-seater options, to suit your group size. Book your bus with Amruta Travels and experience reliable and comfortable transportation in Pune!',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],

     "services": [
    {
      "name": "Affordable Bus Hire in Pune",
      "description": "Amruta Travels offers budget-friendly bus rental options in Pune, ensuring comfort and reliability for all types of group travel. Whether it's a corporate event, family outing, or religious tour, our affordable rates make group travel accessible without compromising on quality."
    },
    {
      "name": "Bus Rental in Pune",
      "description": "Explore Pune and its surroundings with Amruta Travels' diverse fleet of buses available for rent. From small groups to large gatherings, we provide tailored transportation solutions to meet your specific needs, ensuring a smooth and enjoyable journey."
    },
    {
      "name": "Local Bus Hire in Pune",
      "description": "For local travel within Pune, Amruta Travels offers convenient bus hire services. Ideal for school trips, corporate events, or city tours, our buses are well-maintained and driven by experienced chauffeurs to ensure safety and comfort."
    },
    {
      "name": "Pune to Pandharpur & Tuljapur Bus on Rent",
      "description": "Embark on a spiritual journey with Amruta Travels' bus services from Pune to Pandharpur and Tuljapur. Our buses are equipped with comfortable seating and air conditioning, providing a peaceful and comfortable ride to these revered pilgrimage sites."
    },
    {
      "name": "Pune to Kolhapur Bus on Rent",
      "description": "Travel from Pune to Kolhapur in comfort with Amruta Travels' bus rental services. Whether it's a visit to the Mahalakshmi Temple or a family gathering, our buses ensure a comfortable and timely journey to Kolhapur."
    },
    {
      "name": "Pune to Konkan Darshan Bus on Rent",
      "description": "Experience the scenic beauty of the Konkan region with Amruta Travels' bus services from Pune. Our buses are ideal for group tours, offering comfort and convenience as you explore the coastal landscapes and cultural heritage of Konkan."
    },
    {
      "name": "Pune to Shirdi Bus Hire from Hadapsar",
      "description": "For a hassle-free journey to Shirdi from Hadapsar, Amruta Travels provides reliable bus hire services. Our buses are well-maintained and driven by professional drivers, ensuring a safe and comfortable trip to the Sai Baba temple."
    },
    {
      "name": "Rent a Bus in Pune",
      "description": "Amruta Travels offers a wide range of buses for rent in Pune, catering to various group sizes and travel requirements. Whether it's a short city tour or an extended outstation trip, we have the perfect bus to suit your needs."
    },
    {
      "name": "Luxury Bus on Rent in Pune",
      "description": "Indulge in luxury travel with Amruta Travels' premium bus rental services in Pune. Our luxury buses are equipped with modern amenities, ensuring a comfortable and stylish journey for corporate events, weddings, or special occasions."
    },
    {
      "name": "40 Seater Bus on Rent in Pune",
      "description": "Ideal for large groups, Amruta Travels offers 40-seater buses for rent in Pune. Our spacious buses are perfect for school trips, corporate outings, or family gatherings, providing ample space and comfort for all passengers."
    },
    {
      "name": "27 Seater Bus on Rent in Pune",
      "description": "For medium-sized groups, Amruta Travels provides 27-seater buses for rent in Pune. These buses offer a balance of comfort and efficiency, making them suitable for various group travel needs."
    },
    {
      "name": "17 Seater Bus on Rent in Pune",
      "description": "Amruta Travels offers 17-seater buses for rent in Pune, perfect for small group outings, corporate meetings, or family trips. Our compact buses provide comfort and flexibility for shorter journeys."
    },
    {
      "name": "Traveller Bus on Rent in Pune",
      "description": "For personalized group travel, Amruta Travels provides traveller buses for rent in Pune. These vehicles are ideal for small to medium-sized groups, offering comfort and convenience for various travel needs."
    },
    {
      "name": "Bus on Rent in Pune",
      "description": "Amruta Travels offers a variety of buses for rent in Pune, catering to different group sizes and travel requirements. From city tours to outstation trips, we provide reliable and comfortable transportation solutions."
    },
    {
      "name": "Mini Bus on Rent in Pune",
      "description": "For smaller groups, Amruta Travels offers mini buses for rent in Pune. These compact buses are perfect for city tours, school trips, or small family gatherings, providing comfort and convenience."
    },
    {
      "name": "Nashik to Aurangabad Bus on Rent",
      "description": "Travel between Nashik and Aurangabad with Amruta Travels' bus rental services. Our buses are equipped with modern amenities, ensuring a comfortable and timely journey between these two cities."
    }
  ],
  "tableData": [
    ["Affordable Bus Hire in Pune", "Bus Rental in Pune"],
    ["Local Bus Hire in Pune", "Pune to Pandharpur & Tuljapur Bus on Rent"],
    ["Pune to Kolhapur Bus on Rent", "Pune to Konkan Darshan Bus on Rent"],
    ["Pune to Shirdi Bus Hire from Hadapsar", "Rent a Bus in Pune"],
    ["Luxury Bus on Rent in Pune", "40 Seater Bus on Rent in Pune"],
    ["27 Seater Bus on Rent in Pune", "17 Seater Bus on Rent in Pune"],
    ["Traveller Bus on Rent in Pune", "Bus on Rent in Pune"],
    ["Mini Bus on Rent in Pune", "Nashik to Aurangabad Bus on Rent"]
  ],



"whychoose": [
  {
    "WhyChooseheading": "Reliable and Convenient Group Travel",
    "WhyChoosedescription": "Amruta Travels provides trusted Pune Bus Hire Rental Service for all types of group travel. Whether for local trips or outstation tours, we ensure a smooth and stress-free journey."
  },
  {
    "WhyChooseheading": "Suitable for All Occasions",
    "WhyChoosedescription": "Our buses are ideal for weddings, corporate events, school outings, religious trips, and family functions. No matter the event, we have the right bus to meet your needs."
  },
  {
    "WhyChooseheading": "Experienced Drivers and Safe Travel",
    "WhyChoosedescription": "We prioritize safety with licensed, trained, and courteous drivers. Their route knowledge and professionalism make your travel experience secure and comfortable."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Our Pune Bus Hire Rental Service is priced competitively with no hidden charges. We offer clear, upfront pricing to help you stay within your travel budget."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Fleet",
    "WhyChoosedescription": "All our buses are regularly serviced and cleaned to maintain high standards of comfort and hygiene. You travel in a bus that’s reliable, clean, and ready to go."
  },
  {
    "WhyChooseheading": "Flexible Routes and Scheduling",
    "WhyChoosedescription": "We customize pickup and drop-off points, stopovers, and travel timing to match your specific plans. Our flexible scheduling ensures convenience and efficiency."
  },
  {
    "WhyChooseheading": "Multiple Seating Options Available",
    "WhyChoosedescription": "Choose from a wide range of bus sizes—from mini-buses to 50-seaters—to suit your group size and travel preferences. We have the perfect bus for every trip."
  },
  {
    "WhyChooseheading": "Quick Booking and Dedicated Support",
    "WhyChoosedescription": "With our easy booking process and dedicated customer service, arranging a Pune Bus Hire Rental Service is simple and hassle-free. We're here to support you every step of the way."
  }
]





























    }

const faqData = [
  {
    question: 'How can I hire a bus in Pune with Amruta Travels?',
    answer: 'Hiring a bus in Pune with Amruta Travels is simple and hassle-free. You can book through our website, contact our support team, or visit our office. We will help you choose the ideal bus based on your travel plans and group size.',
  },
  {
    question: 'What types of buses are available for hire in Pune?',
    answer: 'We offer a wide range of buses including 32, 35, 45, and 50 seater options. Whether you need a bus for a local event, outstation trip, school tour, or corporate outing, we have the right vehicle for your needs.',
  },
  {
    question: 'Are the buses suitable for different types of events?',
    answer: 'Yes, our buses can be hired for weddings, corporate functions, school trips, religious events, city tours, and more. We provide tailored transportation solutions for all types of group travel.',
  },
  {
    question: 'Are the buses regularly maintained and clean?',
    answer: 'Absolutely. All our buses undergo regular maintenance and are thoroughly cleaned and sanitized before every trip. We prioritize passenger safety, hygiene, and comfort.',
  },
  {
    question: 'How much does it cost to rent a bus in Pune?',
    answer: 'The rental cost depends on factors like the bus size, trip duration, and destination. Please contact us with your requirements to get a customized quote with no hidden charges.',
  },
  {
    question: 'Do you provide buses for both local and outstation travel?',
    answer: 'Yes, our buses are available for both local city use and long-distance outstation trips. We ensure a comfortable and reliable experience for all types of journeys.',
  },
  {
    question: 'Is a driver included in the bus rental service?',
    answer: 'Yes, every bus rental includes a professional, licensed driver who ensures a smooth, punctual, and safe journey for your group.',
  },
  {
    question: 'Can I customize pickup and drop-off points in Pune?',
    answer: 'Yes, we offer flexible pickup and drop-off locations as per your convenience. Just share your route and schedule, and we’ll manage the logistics accordingly.',
  },
  {
    question: 'Why choose Amruta Travels for bus hire services in Pune?',
    answer: 'Amruta Travels is a trusted name for bus rental in Pune. We offer well-maintained buses, professional drivers, reliable service, and a customer-first approach to ensure your travel is seamless and stress-free.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Nilesh Patankar',
    role: 'Business Owner, Pune',
    text: 'We booked a 35-seater bus for a business event. The service was prompt, the bus was clean, and the driver was very cooperative. Amruta Travels made our event transportation completely worry-free.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Kavita Bhandari',
    role: 'School Administrator, Pune',
    text: 'Amruta Travels provided a 50-seater bus for our school trip. The booking process was smooth, and the travel experience was excellent. Highly recommended for anyone looking for reliable bus rental services in Pune.',
    rating: 5,
  },
];








































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Bus Hire Rental Service",
  "image": "https://bushireinpune.com/assets/images/pune-bus-hire-rental-service.jpg",
  "description": "Rent buses in Pune for local and outstation trips like Pandharpur, Kolhapur, Konkan Darshan, Shirdi, and more. Choose from luxury buses, 40-seater, 27-seater, and 17-seater buses for your travel needs with Amruta Travels.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5290"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "60", // Adjust based on per km or flat rate for bus rental
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-bus-hire-rental-service"
  }
};





    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | Pune Bus Hire Rental Service | Affordable Bus Rentals for Local & Outstation Trips | Amruta Travels</title>
  <meta 
    name="description" 
    content="Rent buses in Pune for affordable local and outstation trips including Pandharpur, Shirdi, Kolhapur, and more with Amruta Travels. Luxury buses and mini buses available for all your travel needs." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/17.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punebushirerentalsservice;